import { render, staticRenderFns } from "./ReportingUnits.vue?vue&type=template&id=e95cc94c&scoped=true&"
import script from "./ReportingUnits.vue?vue&type=script&lang=js&"
export * from "./ReportingUnits.vue?vue&type=script&lang=js&"
import style0 from "./ReportingUnits.vue?vue&type=style&index=0&id=e95cc94c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e95cc94c",
  null
  
)

export default component.exports